export const productDataCalzado = [
    {
      id: "1Sandaliasbajas",
      imageurl:
      'https://res.cloudinary.com/dvjmjujc0/image/upload/v1692994670/sandaliabaja_oxkylg.webp',
      name: "Sandalias bajas",
      price: "5000",
      description: "Calzado",
      color: "black",
      IsTalla: "Talla",
      IsSale: "Sale",
      signo: "$",
      pricebefore: "5900",
      colorbc: "pink",
      tallas: [ 36,37,38,39 ], 
      quantity: 1,
    },
    {
        id: "2Sandaliasdetirasyhebilla",
        imageurl:
        'https://res.cloudinary.com/dvjmjujc0/image/upload/v1692994834/sandaliahebilla_zzqbbm.webp',
        name: "Sandalias de tiras y hebilla",
        price: "7800",
        description: "Calzado",
        IsTalla: "Talla",
        IsSale: "Nuevo",      
        colorbc: "pink",
        color: "orange",
        tallas: [ 36,37,38,39],
        quantity: 1,
      },
      {
        id: "3Sandaliasbajasconhebilla",
        imageurl:
        'https://res.cloudinary.com/dvjmjujc0/image/upload/v1692994951/sandaliahebillasola_fpi2kg.webp',
        name: "Sandalias bajas con hebilla",
        price: "4600",
        description: "Calzado",       
        color: "yellow",
        IsTalla: "Talla",
        tallas: [ 38,39, 40],
        quantity: 1,
      },
      {
        id: "4Zapatillasconplataforma",
      imageurl:
        "https://res.cloudinary.com/dvjmjujc0/image/upload/v1692995137/zapatillasplataforma_qi7gjm.webp",
      name: "Zapatillas con plataforma",
      price: "10000",
      description: "Calzado",
      color: "brown",      
      IsTalla: "Talla",
      tallas: [ 36,37,38,39], 
      quantity: 1,
      },
      {
        id: "5Zapatillasdelona",
      imageurl:
        "https://res.cloudinary.com/dvjmjujc0/image/upload/v1692995382/zapatillaslona_cumg4f.webp",
      name: "Zapatillas de lona",
      price: "6000",
      description: "Calzado",
      color: "red-wine",      
      IsTalla: "Talla",
      tallas: [ 37,38,39, 40], 
      quantity: 1,
      },
      {
        id: "6Botasbucaneraselasticas",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_899190-MLA41477374482_042020-O.webp",
      name: "Botas bucaneras elastica",
      price: "15000",
      description: "Calzado",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 36,37,38], 
      quantity: 1,
      },
      {
        id: "7Borcegosdecuero",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_704425-MLA50275476040_062022-O.webp",
      name: "Borcegos de cuero",
      price: "15000",
      description: "Calzado",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 36,37,38, 39], 
      quantity: 1,
      },
      {
        id: "8Botasbucanerasdecuero",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_794543-MLA48917351165_012022-O.webp",
      name: "Botas bucaneras de cuero",
      price: "25000",
      description: "Calzado",
      color: "purple",      
      IsTalla: "Talla",
      tallas: [ 36,37], 
      quantity: 1,
      },
      {
        id: "9Taconescongliter",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_995047-MLA49627092201_042022-O.webp",
      name: "Tacones con gliter",
      price: "10000",
      description: "Calzado",
      color: "white",      
      IsTalla: "Talla",
      tallas: [ 38,39, 40], 
      quantity: 1,
      },
      {
        id: "10Sandaliasdetacon",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_704845-MLA50912372317_072022-O.webp",
      name: "Sandalias de tacón",
      price: "7000",
      description: "Calzado",
      color: "red",      
      IsTalla: "Talla",
      tallas: [ 38,39], 
      quantity: 1,
      },
      {
        id: "11Botinetacontacón",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_935278-MLA51520089181_092022-O.webp",
      name: "Botineta con tacón",
      price: "11000",
      description: "Calzado",
      color: "blue-electric",      
      IsTalla: "Talla",
      tallas: [ 36,37,38], 
      quantity: 1,
      },
      {
        id: "12Zapatillasurbanas",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_709454-MLA51105540631_082022-O.webp",
      name: "Zapatillas urbanas",
      price: "6500",
      description: "Calzado",
      color: "black",      
      IsTalla: "Talla",
      tallas: [ 36,37,38,39], 
      quantity: 1,
      },
      {
        id: "13Zapatillasurbanasaltas",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_931617-MLA51258614611_082022-O.webp",
      name: "Zapatillas urbanas altas",
      price: "6000",
      description: "Calzado",
      color: "white",      
      IsTalla: "Talla",
      tallas: [ 36,37,38], 
      quantity: 1,
      },
      {
        id: "14Zapatillasplancha",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_836230-MLA52164487718_102022-O.webp",
      name: "Zapatillas plancha",
      price: "3000",
      description: "Calzado",
      color: "blue",      
      IsTalla: "Talla",
      tallas: [ 36,37,38], 
      quantity: 1,
      },
      {
        id: "15Zapatillaliviana",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_698141-MLA51694461647_092022-O.webp",
      name: "Zapatillas livianas",
      price: "4000",
      description: "Calzado",
      color: "nute",      
      IsTalla: "Talla",
      tallas: [ 36,37,38,39], 
      quantity: 1,
      },
      {
        id: "16ZapatillasBlanks",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_757043-MLA52633549893_112022-O.webp",
      name: "Zapatillas Blanks",
      price: "17000",
      description: "Calzado",
      color: "green-dark",      
      IsTalla: "Talla",
      tallas: [ 37,38,39], 
      quantity: 1,
      },
  ];